import { createSlice } from "@reduxjs/toolkit";
import {
  addToCart,
  getCart,
  getCartForFamily,
  editCart,
  deleteCart,
  getCartCounter
} from "./thunk";

const initialState = {
  carts: null,
  familyCarts: [],
  cartCounter:null,
  loading: false,
  error: null,
};

const cartSlice = createSlice({
  name: "cartSlice",
  initialState,
  reducers: {
    clearResponses: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {

    // Get cart
    builder
      .addCase(getCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCart.fulfilled, (state, action) => {
        state.loading = false;
        // assume action.payload.data contains array of cart items
        state.carts = action.payload;
      })
      .addCase(getCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });
      builder.addCase(getCartCounter.fulfilled, (state, action) => {
        state.cartCounter = action.payload;
      })

    // Get cart for family
    builder
      .addCase(getCartForFamily.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCartForFamily.fulfilled, (state, action) => {
        state.loading = false;
        // assume action.payload.data contains array of family cart items
        state.familyCarts = action.payload;
      })
      .addCase(getCartForFamily.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

    builder
      .addCase(editCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editCart.fulfilled, (state, action) => {
        state.loading = false;
        const updatedItem = action.payload;
        const index = state.carts.findIndex(
          (item) => item.id === updatedItem.id
        );
        if (index !== -1) state.carts[index] = updatedItem;
      })
      .addCase(editCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

    // Delete cart item
    builder
      .addCase(deleteCart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
    .addCase(deleteCart.fulfilled, (state, action) => {
  state.loading = false;
  const deletedId = action.meta.arg.id;
  if (Array.isArray(state.carts)) {
    state.carts.families = state?.carts?.families?.filter(item => item?.id !== deletedId);
  } 
})

      .addCase(deleteCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
      });
  },
});

export const { clearResponses } = cartSlice.actions;
export default cartSlice.reducer;
